const Common = {
  install(Vue, dispatch) {
    Vue.prototype.$showLoading = function() {
      dispatch('app/showLoading')
    }

    Vue.prototype.$hideLoading = function() {
      dispatch('app/hideLoading')
    }

    Vue.prototype.$showSuccessMessage = function(text) {
      dispatch('app/showSuccessMessage', text)
    }

    Vue.prototype.$showErrorMessage = function(text) {
      dispatch('app/showErrorMessage', text)
    }
  }
}

export default Common
